var getNative = require('./_getNative');

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/lodash/_defineProperty.js
// module id = 661
// module chunks = 0 1 2 3 4 5 6 7 8